import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

export const useDeleteSubset = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ matterId, subsetId }: { matterId: string; subsetId: string }) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.DELETE,
      });

      const res = await fetch(`${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}`, fetchConfig);

      if (!res.ok) {
        throw new Error(`Failed to delete subset: ${res.statusText}`);
      }

      return { matterId, subsetId };
    },
    onSuccess: ({ matterId }) => {
      toast.success('Subset deleted successfully');
      queryClient.invalidateQueries({ queryKey: [QueryEntity.DocSubsets, { matterId }] });
    },
    onError: (error) => {
      console.error('Delete subset error:', error);
      toast.error('Failed to delete subset. Please try again.');
    },
  });
};
